import { mapData } from '@/utilities/DataMapping';
import { BookingAllocation, IBookingAllocation } from '@/model/BookingAllocation';
import { BookingAllocationDateVM, IBookingAllocationDateVM } from './BookingAllocationDateVM';
import { Employee, IEmployee } from '@/model/Employee';

export interface IBookingAllocationVM {
    allocation: IBookingAllocation;
    employee: IEmployee;
    employeeRegistered: boolean;
    dates: Array<IBookingAllocationDateVM>;

    isSelected: boolean;
}

export class BookingAllocationVM implements IBookingAllocationVM {

    constructor(data?: IBookingAllocationVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingAllocationVM) {
        mapData(data, {
            root: () => this,
            allocation: () => new BookingAllocation(),
            employee: () => new Employee(),
            dates: () => new BookingAllocationDateVM()
        });
    }

    allocation: any = new BookingAllocation;
    employee: any = new Employee;
    employeeRegistered: boolean = false;
    dates: Array<BookingAllocationDateVM> = [];

    isSelected: boolean = false;

    get employeeLinkIconColour() {
        if (this.isSelected) {
            return "darkCyan";
        } else {
            return "lightGray";
        }
    }

    get employeeDatesInPast() {
        let retVal = false;

        for (const date of this.dates) {
            if (date.dateInPast && date.dateAssigned) {
                retVal = true;
            }
        }

        return retVal;
    }

    get employeeTextColour() {
        return this.employeeRegistered ? "black" : "red";
    }
}